export default "__VITE_ASSET__DF85HlBU__"